import { useTranslation } from 'react-i18next';

const GAME_TYPE_CONFIG = {
    BOARDGAME: { labelKey: 'main.game_search.game_type_boardgame', bg: '#7c3aed' },
    RPG:       { labelKey: 'main.game_search.game_type_rpg',       bg: '#ea580c' },
    VIDEOGAME: { labelKey: 'main.game_search.game_type_videogame', bg: '#16a34a' },
};

function GameTypeBadge({ gameType }) {
    const { t } = useTranslation('messages');

    if (!gameType) return null;

    const config = GAME_TYPE_CONFIG[gameType];
    if (!config) return null;

    return (
        <span style={{
            backgroundColor: config.bg,
            color: '#fff',
            fontSize: '0.7rem',
            fontWeight: 600,
            padding: '2px 8px',
            borderRadius: '0.375rem',
            whiteSpace: 'nowrap',
        }}>
            {t(config.labelKey)}
        </span>
    );
}

export default GameTypeBadge;
